import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import axios from 'axios'
import TurnOffAutocomplete from 'vue-turn-off-autocomplete'
import CountryFlag from 'vue-country-flag'
import mixin from '@/plugins/mixin'

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.use(TurnOffAutocomplete)
Vue.component('country-flag', CountryFlag)
Vue.mixin(mixin)

new Vue({
  router,
  store,
  vuetify,
  beforeCreate () {
    this.$store.commit('initStore')
  },
  render: h => h(App)
}).$mount('#app')
